import { useState } from 'react';

export const useCircularIterator = (length: number, defaultIndex: number): [number, () => void, () => void] => {
    const [activeIndex, setActiveIndex] = useState(defaultIndex);
    const lastIndex = length - 1;

    const prev = () => {
        setActiveIndex(currentIndex => (currentIndex === 0 ? lastIndex : currentIndex - 1));
    };

    const next = () => {
        setActiveIndex(currentIndex => (currentIndex === lastIndex ? 0 : currentIndex + 1));
    };

    return [
        activeIndex,
        prev,
        next,
    ];
};
